export interface TripWindow {
  pickup_at?: string;
  return_at?: string;
}

/**
 * 126: the query-string contract three separate pages agree on
 * (specs/126-trip-context-passthrough/contracts/query-params.md). `location_id` is
 * deliberately never part of this — see research.md D1.
 */
export function tripQueryString(trip: TripWindow): string {
  const params = new URLSearchParams();
  if (trip.pickup_at) params.set('pickup_at', trip.pickup_at);
  if (trip.return_at) params.set('return_at', trip.return_at);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

/** Parses a carried-forward query value; `null` for absent or unparseable input —
 * never a garbage `Date` a caller might forget to guard against. */
export function parseCarriedDate(value?: string): Date | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
